export const formatCurrency = (
  amount: number = 0,
  locale: string,
  currency = "XOF"
) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  })
    .format(amount)
    .replace(/[\u00a0\u202f]/g, " ");
};
